import {primaryColor, textBlack, webFont} from '../../config/theme';

const style = {
	logoMobile: {
		cursor: 'pointer',
		maxWidth: '60%'
	},
	logo: {
		cursor: 'pointer',
		maxHeight: '60px'
	},
	menuIcon: {
		color: textBlack,
		fontSize: '36px'
	},
	errorIcon: {
		color: 'red',
		fontSize: '20px',
		marginLeft: 10,
	},
	navMenu: {
		display: 'flex',
		top: 10,
		alignItems: 'center',
	},
	sidebar: {
		width: 200
	},
	mobileNavMenu: {
		display: 'flex',
		width: '100%'
	},
	mobileMenuItem: {
		color: textBlack,
		textDecoration: 'none',
		fontSize: '16px',
		fontFamily: 'Poppins',
		outline: 'none !important',
	},
	navMenuItem: {
		color: textBlack,
		textDecoration: 'none',
		fontSize: '18px',
		fontFamily: 'Poppins',
		marginRight: '44px',
		marginTop: 0,
		textTransform: 'none',
		outline: 'none !important',
	},
	navMenuItemLogin: {
		color: textBlack,
		textDecoration: 'none',
		fontSize: '18px',
		fontFamily: 'Poppins',
		marginLeft: '25px',
		//marginTop: '15px',
		textTransform: 'none'
	},
	stepSelected: {
		fontSize: 15,
		fontWeight: 500,
		color: "#000000",
		fontFamily: webFont,
		outline: 'none !important',
		textDecoration: 'none'
	},
	navMenuItemHover: {
		textDecoration: 'none',
		fontSize: '18px',
		fontFamily: 'Poppins',
		marginRight: '44px',
		color: primaryColor,
		textTransform: 'none',
		outline: 'none !important',
	},
	navMenuItemHoverMobile: {
		textDecoration: 'none',
		fontSize: '16px',
		fontFamily: 'Poppins',
		/*marginLeft: '25px',
		marginTop: '15px',*/
		color: primaryColor,
		/*borderBottomWidth: '4px',
		borderBottomColor: primaryColor,
		borderBottomStyle: 'solid',*/
		textTransform: 'none'
	},
	avatarImg: {
		backgroundColor: 'transparent',
		width: 36,
		height: 36,
		borderColor: primaryColor,
		borderWidth: 7
	},
};

export default style;
